const getVideoMeetingValue = (contactID: string, videoMeetingAttribute?: string) => {
    const list = videoMeetingAttribute?.split(',')
    const found = list?.find((x) => x.includes(contactID))
    return found?.split('_')[1]
}

export default getVideoMeetingValue
